import { io } from "socket.io-client";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3005/api/v1";
// Ensure we have a clean domain without ports or trailing slashes
const getWsUrl = () => {
  if (process.env.REACT_APP_WS_URL) return process.env.REACT_APP_WS_URL;
  
  // If no WS_URL is provided, derive it from API_URL
  // This regex removes /api/v1 AND any trailing slashes
  return API_BASE_URL.replace(/\/api\/v1\/?$/, "");
};

const WS_BASE_URL = getWsUrl();
// const WS_BASE_URL = process.env.REACT_APP_WS_URL || API_BASE_URL.replace(/\/api\/v1$/, "");

export function createDashboardRealtimeClient({
  range = "30d",
  onSnapshot,
  onUpdate,
  onError,
}) {
  let activeRange = range;

  const socket = io(WS_BASE_URL, {
    transports: ["polling", "websocket"],
    upgrade: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on("connect", () => {
    socket.emit("analytics:dashboard:subscribe", { range: activeRange });
  });

  socket.on("analytics:dashboard:snapshot", (payload) => {
    if (onSnapshot) onSnapshot(payload);
  });

  socket.on("analytics:dashboard:update", (payload) => {
    if (onUpdate) onUpdate(payload);
  });

  socket.on("connect_error", (err) => {
    if (onError) onError(err?.message || "Realtime connection failed");
  });

  socket.on("error", (err) => {
    if (onError) onError(err?.message || "Realtime stream error");
  });

  return {
    get socket() {
      return socket;
    },

    requestSnapshot() {
      socket.emit("analytics:dashboard:get", { range: activeRange });
    },

    setRange(nextRange) {
      activeRange = nextRange;
      socket.emit("analytics:dashboard:unsubscribe");
      socket.emit("analytics:dashboard:subscribe", { range: activeRange });
      socket.emit("analytics:dashboard:get", { range: activeRange });
    },

    disconnect() {
      socket.emit("analytics:dashboard:unsubscribe");
      socket.removeAllListeners();
      if (socket.connected || socket.active) {
        socket.disconnect();
      }
    },
  };
}
